import React, { useEffect } from "react";
import { preLoaderAnim } from "../../Animation";
import './Preloader.css'
import { motion } from 'framer-motion'

const PreLoader = () => {
  useEffect(() => {
    preLoaderAnim();
  }, []);
  return (
    <motion.div className="preloader" >
      <div className="texts-container">
        <span>Central</span>
        <span className="ornage" >Industries</span>
        <span>Kandy</span>
      </div>
    </motion.div>
  );
};

export default PreLoader;